export interface IComparePPData {
  type: 'standard' | 'simplified'
  preview: string
  conditions: { action?: VoidFunction; text: ConditionDesc[]; labelKey: LabelKeys; id: number }[]
  action: { fn: VoidFunction; title: string }
}

export type ConditionDesc = string | [string, string]

export type LabelKeys = 'location' | 'placement' | 'area' | 'renovation' | 'branding' | 'deposit'

export const enum pickpointType {
  standard = 'standard',
  simplified = 'simplified',
}
